import { AudioRecorderTranslations } from '@/components/AudioRecorder/i18n';
import { ChatTranslations } from '@/components/Chat';
import { DeliverableListTranslations } from '@/components/DeliverableList';
import { DeliverableUploadTranslations } from '@/components/DeliverableUpload';
import { DeliverableViewerTranslations } from '@/components/DeliverableViewer';
import { EventAttendConfirmationTranslations } from '@/components/EventAttendConfirmation';
import { FlashcardsCommonTranslations } from '@/components/Flashcards';
import { InfoTestStudentBannerTranslations } from '@/components/InfoTestStudentBanner/i18n';
import { ProductTourTranslations } from '@/components/ProductTour';
import { StudentProfileTranslations } from '@/components/ProfilePreviewModal';
import { StudentQuizProgressTranslations } from '@/components/QuizProgress';
import { SectionReviewTranslations } from '@/components/SectionReview';
import { DefaultTranslations, RoutesTranslations } from '@/i18n/locales/common';
import {
  AcademiesTranslations,
  AcademyDetailTranslations,
  UsersTranslations,
  AITeachersTranslations,
  AdminPromptsTranslations
} from '@/pages/Admin';
import {
  LoginTranslations,
  RecoverTranslations,
  CoursesTranslations,
  CourseTranslations,
  CourseTagsTranslations,
  CommonEventsTranslations,
  CommonEventTranslations,
  CommonDashboardTranslations,
  CommonTicketsTranslations,
  ExamGroupsTranslations,
  CommonQuizFormTranslations,
  CommonTutoringGroupsTranslations,
  CommonTutoringGroupTranslations,
  CommonQuestionBankTranslations,
  ProblemReportsTranslations
} from '@/pages/Common';
import {
  DemoDayRankingTranslations,
  MyAcademyTranslations,
  ManagerTeachersTranslations,
  ManagerInternalUsersTranslations,
  ManagerQuizzesTranslations,
  ManagerActivityStatsTranslations,
  IndexationLandingsTranslations,
  ManagerExamsTranslations,
  ManagerExamDetailTranslations,
  ManagerTeacherDetailTranslations,
  ManagerStudentDetailTranslations,
  ManagerPostPanelPageTranslations
} from '@/pages/Manager';
import {
  StudentCourseTranslations,
  StudentTicketsTranslations,
  StudentQuizzesTranslations,
  StudentQuizTranslations,
  StudentQuizProgressByCourseTranslations,
  StudentQuizProgressByCourseSectionTranslations,
  StudentProfileConfigurationTranslations,
  StudentCourseSummaryTranslations,
  RankingTranslations,
  StudentOnboardingPageTranslations,
  StudentEventsTranslations,
  StudentRateYourExperienceTranslations,
  StudentTutorVoteTranslations,
  StudentTeacherVoteTranslations,
  StudentLiveClassVoteTranslations,
  StudentQuizConfigurationTranslations,
  StudentQuizHistoryTranslations,
  StudentFlashcardTranslations,
  StudentFlashcardCollectionTranslations,
  FlashcardsPracticeTranslations,
  StudentQuizResultTranslations,
  StudentDashboardTranslations,
  ExamGroupTranslations,
  StudentExamScoreTranslations
} from '@/pages/Student';
import {
  TeacherExamGroupsTranslations,
  TeacherStudentsPageTranslations,
  TeacherProfileTranslations,
  TeacherExamsTranslations,
  TeacherExamDetailTranslations,
  TeacherDeliverablesTranslations
} from '@/pages/Teacher';

export const namespaces = {
  DefaultTranslations,
  StudentQuizProgressByCourseTranslations,
  StudentQuizProgressByCourseSectionTranslations,
  StudentQuizProgressTranslations,
  RoutesTranslations,
  LoginTranslations,
  RecoverTranslations,
  UsersTranslations,
  AcademiesTranslations,
  AcademyDetailTranslations,
  CoursesTranslations,
  CourseTranslations,
  CourseTagsTranslations,
  StudentQuizTranslations,
  MyAcademyTranslations,
  ManagerTeachersTranslations,
  StudentCourseTranslations,
  ManagerQuizzesTranslations,
  CommonQuizFormTranslations,
  StudentTicketsTranslations,
  CommonTicketsTranslations,
  CommonTutoringGroupsTranslations,
  CommonEventsTranslations,
  StudentQuizzesTranslations,
  CommonDashboardTranslations,
  CommonEventTranslations,
  EventAttendConfirmationTranslations,
  DeliverableListTranslations,
  StudentProfileTranslations,
  StudentProfileConfigurationTranslations,
  AITeachersTranslations,
  AdminPromptsTranslations,
  ProblemReportsTranslations,
  CommonTutoringGroupTranslations,
  ExamGroupsTranslations,
  ManagerInternalUsersTranslations,
  IndexationLandingsTranslations,
  ManagerActivityStatsTranslations,
  ChatTranslations,
  DeliverableUploadTranslations,
  DeliverableViewerTranslations,
  TeacherExamGroupsTranslations,
  TeacherStudentsPageTranslations,
  StudentCourseSummaryTranslations,
  RankingTranslations,
  SectionReviewTranslations,
  TeacherProfileTranslations,
  TeacherExamsTranslations,
  TeacherExamDetailTranslations,
  ManagerExamsTranslations,
  ManagerExamDetailTranslations,
  ProductTourTranslations,
  StudentEventsTranslations,
  TeacherDeliverablesTranslations,
  StudentRateYourExperienceTranslations,
  StudentTutorVoteTranslations,
  StudentTeacherVoteTranslations,
  StudentLiveClassVoteTranslations,
  CommonQuestionBankTranslations,
  ManagerTeacherDetailTranslations,
  StudentQuizConfigurationTranslations,
  StudentQuizHistoryTranslations,
  StudentFlashcardTranslations,
  FlashcardsCommonTranslations,
  StudentFlashcardCollectionTranslations,
  FlashcardsPracticeTranslations,
  AudioRecorderTranslations,
  StudentQuizResultTranslations,
  ExamGroupTranslations,
  InfoTestStudentBannerTranslations,
  StudentOnboardingPageTranslations,
  StudentDashboardTranslations,
  StudentExamScoreTranslations,
  ManagerStudentDetailTranslations,
  ManagerPostPanelPageTranslations,
  DemoDayRankingTranslations
} as const;
